export function getSegmentedControlProps({ status, filters, selectedIndex, onClick, }) {
    return status === "Unauthorized" ? {
        variant: "settlementStatusFilters:Disabled",
        options: filters,
        selectedOptionIndex: selectedIndex,
        onClick: () => undefined,
        testId: "my-bets-status-filters",
    } : {
        variant: "settlementStatusFilters",
        options: filters,
        selectedOptionIndex: selectedIndex,
        onClick: (status === "Loading" || status === "Initial") ? () => undefined : onClick,
        testId: "my-bets-status-filters",
    };
}
//# sourceMappingURL=getSegmentedControlProps.js.map